import React, { useState } from 'react';
import ProjectsSection from '../components/projects/index';
import ImgMediaCard from '../components/ui-elements/mui-card/index';
import { Heading3 } from '../typography/typography';
import Slide from 'react-reveal/Slide';


export default function ProjectsContainer() {

    const [projects, setProjects] = useState([
        {
            src:"/svgs/web.svg",
            title:"Web Application Development"
        },
        {
            src:"/svgs/brain.svg",
            title:"Machine Learning"
        },
        {
            src:"/svgs/data-analysis.svg",
            title:"Data Analysis"
        },
        {
            src:"/svgs/android.svg",
            title:"Android Application Development" 
        },
        {
            src:"/svgs/c++.svg",
            title:"C++ Programming"
        }
    ]);

    return (
        <ProjectsSection id="projects">
            <Heading3>PROJECTS</Heading3>
                <ProjectsSection.ContentContainer>

                <Slide bottom>
                    {projects.map((project) => <ImgMediaCard
                    key={project.title}
                    src={project.src}
                    title={project.title}
                    projects
                    />)}
                </Slide>
                </ProjectsSection.ContentContainer>
            
        </ProjectsSection>
    )
}